import createScriptTag from './createScriptTag';
import Track from './tracking';

export default class DomUtils {
  static enableBodyScrollLock() {
    document.body.classList.add('no-scroll');
  }
  
  static disableBodyScrollLock() {
    document.body.classList.remove('no-scroll');
  }
  
  static scrollToTop(behavior = 'smooth') {
    try {
      window.scrollTo({top: 0, behavior});
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }
  
  static jumpToTop() {
    DomUtils.scrollToTop('instant');
  }
  
  static scrollToElement(elRef, yOffset) {
    const y = elRef?.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({top: y, behavior: 'smooth'});
  }
  
  static addScript(src, defer = true, integrity = '', importance = '', async = false, id = '') {
    if (!document.querySelector(`script[src="${src}"]`)) {
      return new Promise((resolve, reject) => {
        document.body.appendChild(createScriptTag(src, resolve, reject, defer, integrity, importance, async, id));
      });
    }
  
    return Promise.resolve();
  }
  
  static waitForEvent(eventType, timeout = 10000) {
    return new Promise((resolve, reject) => {
      if (document.addEventListener) {
        document.addEventListener(eventType, resolve, false);
      } else if (document.attachEvent) {
        document.attachEvent(eventType, resolve);
        document.attachEvent(`on${eventType}`, resolve);
      } else {
        throw new Error('Can\'t attach event listener');
      }
      setTimeout(() => {
        Track.error(`Listeners for ${eventType} timed out`);
        reject();
      }, timeout);
    });
  }
  
  static closeOverlayIfClosable() {
    const closeButton = document.querySelector('#OverlayHeader__exit-button');
    if (!closeButton) return false;
    closeButton.click();
    return true;
  }
  
  static scrollToTopOfOverlay() {
    document.getElementById('CheckoutOverlay__content').scrollTo(0, 0);
  }
}
